import EntityTypeEnum from 'common/enums/entityTypeEnum'
import EntityInterface from 'common/types/entities/EntityInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import React from 'react'
import { Search } from 'src/editor/shared/entities/search'
import { SearchResults } from 'src/editor/shared/entities/search-results'
import { BaseEntityNewInterface } from 'src/shared/schemas/base-entity.schema'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import {
  AdditionalProps,
  createWebsiteEntityElement,
} from './create-website-entity-element'

export const createEntityElementForWebsiteSearch = (
  entity: EntityInterface | OldEntityInterface | BaseEntityNewInterface,
  additionalProps: AdditionalProps,
) => {
  switch (entity.type) {
    case EntityTypeEnum.Search:
      return (
        <Search
          entity={entity as SearchInterface}
          key={`entity-${entity.id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResults
          entity={entity as SearchResultsInterface}
          key={`entity-${entity.id}`}
          isSaveAllowed={false}
          isRemoveAllowed={false}
          isCopyAllowed={false}
          {...additionalProps}
        />
      )
    default:
      return createWebsiteEntityElement(entity, additionalProps)
  }
}
